import Tabs from "apps/website/components/feature/Tabs/Tabs";
import Section from "apps/website/components/layout/Section/Section";
import Container from "apps/website/components/layout/Container/Container";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

import {
  recipeComparisonKatkinVariantData,
} from "./shared/recipeComparisonKatkinVariantData";

export default function SectionRecipeComparisonVariant() {
  return (
    <Section component="SectionRecipeComparison" className="pb-8 xl:pb-0">
      <Container padding="none">
        <div className="mx-auto max-w-[875px]">
          <TextTitle size={1} align="center" whitespace="balance" className="mb-4" data-testid="SectionRecipeComparison-title">
            <span className="bg-brand block w-fit mx-auto">7</span>tasty, vet-formulated recipes
          </TextTitle>
          <TextSubtitle size={1} align="center" className="mb-4" data-testid="SectionRecipeComparison-subtitle">
            For bowls licked clean, every time.
          </TextSubtitle>
        </div>
        <Tabs
          tabs={recipeComparisonKatkinVariantData.tabs}
          defaultActiveTab={recipeComparisonKatkinVariantData.defaultActiveTab}
        />
      </Container>
    </Section>
  );
}
